import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

const useSupervisorHomeData = () => {
	const overview = useSelector(
		(state: StoreType) => state.supervisorHome.overview
	);
	const status = useSelector(
		(state: StoreType) => state.supervisorHome.fetchOverview.status
	);
	const errorMessage = useSelector(
		(state: StoreType) => state.supervisorHome.fetchOverview.errorMessage
	);
	const fetchedAt = useSelector(
		(state: StoreType) => state.supervisorHome.fetchOverview.fetchedAt
	);
	const firstName = useSelector(
		(state: StoreType) => state.user?.userData?.firstName
	);

	return {
		overview,
		snapshot: overview?.snapshot,
		queue: overview?.queue,
		enabledFeatures: overview?.enabledFeatures,
		isLoading: status === "idle" || status === "pending",
		// A refetch keeps the previous numbers on screen — only the very first
		// load has nothing to show, so only it gets skeletons.
		isInitialLoading:
			(status === "idle" || status === "pending") && overview === null,
		isError: status === "error",
		errorMessage,
		fetchedAt,
		firstName,
	};
};

export default useSupervisorHomeData;
